import { Lock } from "./lock";
import { BikeType } from "./bike-type.enum";
import { Group, GroupLight } from "./group";
import { Station } from "./station";

export class AttachmentPoint {
  id: number;
  name: string;
  tag: string;
  type: string; // TODO
  stationId?: number;
  stationName?: string;
  bikeId?: number;
  bikeName?: string;
  groupId: number;
  groupName: string;

  station: Station;
  group: Group;

  deleted: boolean;
}

export enum AttachmentPointType {
  MECHANICAL = "MECHANICAL",
  ELECTRICAL = "ELECTRICAL"
}



// WEBPACK FOOTER //
// ./src/app/models/attachmentpoint.ts